<template>

    <div ref="container" class="table-container" :class="classes" @scroll="handleScroll">
        <table class="table">
            <slot></slot>
        </table>
    </div>

</template>

<style lang="scss">

    .table-container {
        &.scrollable {
            overflow-x: auto;
            overflow-y: hidden;
            &.bordered {
                border: 1px solid $color-rule;
            }
            &.scrolled .table th.sticky-left {
                background: $color-bg;
                border-right: 1px solid $color-rule;
            }
            &.scrolled .table td.sticky-left {
                background: $color-white;
                border-right: 1px solid $color-rule;
            }
            .table {
                border: none;
                border-collapse: separate;
            }
        }
        &.bordered:not(.scrollable) .table {
            border: 1px solid $color-rule;
            tbody tr:last-child td {
                border-bottom: none;
            }
        }
        display: block;
        max-width: 100%;
        min-width: 0;
        position: relative;
        width: 100%;
        &.padded .table thead th,
        &.padded .table tbody td {
            padding: 10px;
        }
        &.condensed .table tbody tr td {
            height: auto;
            padding: 10px 0;
            &:first-child {
                color: $color-muted;
            }
        }
        &.small .table {
            thead th {
                @include font-semibold(10px);
            }
            tbody td {
                @include font-regular(12px);
            }
            tfoot td {
                @include font-regular(12px);
            }
        }
    }

    .table {
        background: $color-white;
        border: none;
        border-collapse: collapse;
        border-spacing: 0;
        margin: 0;
        padding: 0;
        width: 100%;
        .sticky-right {
            background: $color-white;
            border-left: 1px solid $color-rule;
            position: sticky;
            right: 0;
            z-index: 1;
        }
        .sticky-left {
            position: sticky;
            left: 0;
            z-index: 1;
        }
        thead {
            background: $color-bg;
            border: none;
            padding: 0;
            position: relative;
            z-index: 2;
            th {
                @include font-semibold(11px);
                background: $color-bg;
                border: none;
                border-bottom: 1px solid $color-rule;
                color: $color-text;
                line-height: normal;
                padding: 10px 15px;
                text-align: left;
                transition: background-color .3s;
                vertical-align: middle;
                white-space: nowrap;
                div, span {
                    padding: 0;
                }
            }
        }
        tbody {
            border: none;
            tr {
                background: $color-white;
                border: none;
                transition: background-color .3s;
                &.highlighted {
                    background: $color-highlight;
                }
            }
            td {
                @include font-regular(13px);
                background: none;
                border: none;
                border-bottom: 1px solid $color-rule-light;
                color: $color-text;
                height: 50px;
                line-height: normal;
                padding: 0 15px;
                text-align: left;
                vertical-align: middle;
                white-space: nowrap;
                a {
                    color: $color-text;
                }
            }
        }
        tfoot {
            border: none;
            border-top: 1px solid $color-rule;
            margin: 0;
            padding: 0;
            tr {
                border: none;
            }
            td {
                border: none;
                padding: 10px 15px;
            }
        }
    }

    .table-container.selectable .table {
        tbody tr {
            cursor: pointer;
            &:hover {
                background-color: $color-highlight;
            }
        }
    }

    .table-container.vlines .table {
        thead th, tbody td {
            border-left: 1px solid $color-rule;
        }
    }

</style>

<script>

export default {

    props: {
        bordered: {
            type: Boolean,
            default: false,
        },
        condensed: {
            type: Boolean,
            default: false,
        },
        padded: {
            type: Boolean,
            default: false,
        },
        scrollable: {
            type: Boolean,
            default: false,
        },
        selectable: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
        vlines: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            scrolled: false,
        };
    },

    computed: {

        classes() {
            return {
                bordered: this.bordered,
                condensed: this.condensed,
                padded: this.padded,
                scrolled: this.scrolled,
                scrollable: this.scrollable,
                selectable: this.selectable,
                small: this.small,
                vlines: this.vlines,
            };
        },

    },

    mounted() {
        this.checkScroll();
    },

    methods: {

        handleScroll() {
            this.checkScroll();
        },

        checkScroll() {
            if (this.$refs.container) {
                this.scrolled = this.$refs.container.scrollLeft > 0;
            }
        },

    },

}

</script>